/** What an owner sees while they don't have dashboard access. */
export type AccountGateView =
  | "confirming"
  | "pay"
  | "trial_ended"
  | "waiting_for_plan";

export interface PendingPaymentSummary {
  summary: string;
  testMode: boolean;
}

/** Keep in sync with AUTO_SUPPORT_GRANT_MARKER in _shared/staffOnboarding.ts. */
export const AUTO_SUPPORT_GRANT_MARKER = "dibs-staff-onboarding";

export const DIBS_CONTACT_URL = "https://wa.me/6587169250";

/**
 * The plan Dibs staff chose for this account, if any. internal-onboarding-checkout
 * stores it on temporary_metadata, which the owner can read but not edit.
 */
export function readPendingPayment(temporaryMetadata: unknown): PendingPaymentSummary | null {
  if (!temporaryMetadata || typeof temporaryMetadata !== "object") return null;
  const pending = (temporaryMetadata as { pendingPayment?: unknown }).pendingPayment;
  if (!pending || typeof pending !== "object") return null;
  const { priceIds, summary, testMode } = pending as {
    priceIds?: unknown;
    summary?: unknown;
    testMode?: unknown;
  };
  if (!Array.isArray(priceIds) || priceIds.length === 0) return null;
  return {
    summary: typeof summary === "string" ? summary : "",
    testMode: testMode === true,
  };
}

export function accountGateView(state: {
  confirmingPayment: boolean;
  pending: PendingPaymentSummary | null;
  trialEnded: boolean;
}): AccountGateView {
  if (state.confirmingPayment) return "confirming";
  if (state.pending) return "pay";
  return state.trialEnded ? "trial_ended" : "waiting_for_plan";
}

/**
 * Accounts Dibs provisioned on someone's behalf. AuthContext signs out a brand-new
 * account when self-serve is closed, and these are new by design: a client who sets
 * their password and signs in within two minutes must not be turned away.
 */
export function isStaffProvisionedUser(user: {
  user_metadata?: Record<string, unknown> | null;
}): boolean {
  const metadata = user.user_metadata ?? {};
  return (
    metadata.dibs_staff_onboarded === true ||
    metadata.dibs_staff_invite === true ||
    metadata.onboarding_password_set === true
  );
}
